export default __webpack_public_path__ + "static/media/testimonialBanner.a18d0293.webp";